/* ==================================================
#Featured collection
#Featured promotions
#Slideshow
#Testimonials
#Gallery
#Video
#Cart
#Product
#Header
#Social media
#Map
#FAQ


/*============================================================================
  Featured collection
==============================================================================*/
window.uaLocation = false;
var arrowIconSvg = '<svg class="slider-button-icon" viewBox="0 0 100 100"><path d="M41,50l35.8-35.8c1.6-1.6,2.4-3.8,2.4-5.9s-0.8-4.3-2.4-5.9c-3.3-3.3-8.5-3.3-11.8,0L23.3,44.1c-1.6,1.6-2.4,3.8-2.4,5.9 c0,2.1,0.8,4.3,2.4,5.9l41.7,41.7c1.6,1.6,3.8,2.4,5.9,2.4c2.1,0,4.3-0.8,5.9-2.4c3.3-3.3,3.3-8.5,0-11.8L41,50z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>';

var bravaCookie = {
  getCookie: function(name) {
    var matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ))
    return matches ? decodeURIComponent(matches[1]) : undefined
  },
  setCookie: function(name, value, props) {
    props = props || {}
    var exp = props.expires

    if (typeof exp == "number" && exp) {
      var d = new Date()
      d.setTime(d.getTime() + exp*1000)
      exp = props.expires = d
    }

    if(exp && exp.toUTCString) { props.expires = exp.toUTCString() }

    value = encodeURIComponent(value)
    var updatedCookie = name + "=" + value

    for(var propName in props){
      updatedCookie += "; " + propName
      var propValue = props[propName]
      if(propValue !== true){ updatedCookie += "=" + propValue }
    }
	  document.cookie = updatedCookie
  },
  deleteCookie: function(name) {
    bravaCookie.setCookie(name, null, { expires: -1 })
  }
};

var collectionsSliderSection = {
  init: function() {
    $('.collections-slider').slick({
      nextArrow: '<button type="button" class="slick-next">' + arrowIconSvg + '</button>',
      prevArrow: '<button type="button" class="slick-prev">' + arrowIconSvg + '</button>',
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 2,
      lazyLoad: 'ondemand',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            infinite: false,
            arrows: false
          }
        }
      ]
    });
  }
}

var collectionPreviewSection = {
  init: function() {
    var sections = $('.js-collection-preview');
    var collectionSliderInitialized = false;

    var initCollectionSlider = function() {
      collectionSliderInitialized = true;
      $('.products-list', sections).slick({
        lazyLoad: 'ondemand',
        nextArrow: '<button type="button" class="slick-next">'+arrowIconSvg+'</button>',
        prevArrow: '<button type="button" class="slick-prev">'+arrowIconSvg+'</button>',
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      });
    };

    $(window).on('resize', function() {
      if ($(window).width() <= 480 && !collectionSliderInitialized) {
        initCollectionSlider();
      } else if ($(window).width() > 480 && collectionSliderInitialized) {
        collectionSliderInitialized = false;
        $('.products-list', sections).slick('unslick');
      }
    });

    if ($(window).width() <= 480) {
      initCollectionSlider();
    }
  }
}

var logoBarSection = {
  init: function() {
    var sections = $('.logo-list-section');

    sections.each(function() {
      $(this).find('.logo-bar').flickity({
        "cellSelector": '.logo-bar__item',
        "draggable": true,
        "prevNextButtons": true,
        "imagesLoaded": true,
        "wrapAround": true,
        "watchCSS": true,
        "cellAlign": 'left',
        "adaptiveHeight": true,
        "groupCells": true,
        "pageDots": true,
        "contain": true,
        "adaptiveHeight": false,
        "freeScroll": false,
        "arrowShape": 'M41,50l35.8-35.8c1.6-1.6,2.4-3.8,2.4-5.9s-0.8-4.3-2.4-5.9c-3.3-3.3-8.5-3.3-11.8,0L23.3,44.1c-1.6,1.6-2.4,3.8-2.4,5.9 c0,2.1,0.8,4.3,2.4,5.9l41.7,41.7c1.6,1.6,3.8,2.4,5.9,2.4c2.1,0,4.3-0.8,5.9-2.4c3.3-3.3,3.3-8.5,0-11.8L41,50z'
      });
    });
  }
}

var featuredCollectionSection = {
  init: function(){
    $('.js-product-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign = 'left',
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).slick({
        nextArrow: '<button type="button" class="slick-next">'+arrowIconSvg+'</button>',
        prevArrow: '<button type="button" class="slick-prev">'+arrowIconSvg+'</button>',
        dots: usePageDots,
        arrows: prevNext,
        infinite: wrapAround,
        slidesToShow: 4,
        slidesToScroll: 2,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 798,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
        ]
      });

      $(this).addClass('slider-initialized');
    });
  },
  unload: function($target){
    var $slider = $target.find('.js-product-slider');
    if ($slider.hasClass('slider-initialized')){
      $slider.slick('unslick');
    }
  }
}

/*============================================================================
  Featured promotions
==============================================================================*/
var featuredPromotions = {
  init: function(){
    if ($(window).width() > 798 || $(window).width() == 0) {
      $('.feature-overlay').hover(function(){
        $(this).find('.feature-details').slideDown('100', function(){
          $(this).addClass('reveal-details');
        });
      }, function(){
        $(this).find('.feature-details').removeClass('reveal-details');
        $(this).find('.feature-details').slideUp('100');
      });

      $('.js-featured-promotions').each(function (index, value){
        var $promos = $(this);
        var animationStyle = $(this).data('promo-animation');

        $promos.waypoint(function() {
          $(this.element).find(".feature-section").addClass("animated " + animationStyle);
        }, { offset: '80%' });
      });
    }
  }
}

/*============================================================================
  Slideshow
==============================================================================*/

var slideshow = {
  init: function(){

    $('.js-homepage-slideshow').each(function (index, value){
      var $homepageSlider = $(this);
      var settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation'),
        adaptiveHeight: $homepageSlider.data('adaptive-height')
      }

      //initiate the slideshow
      if (!$homepageSlider.hasClass('flickity-enabled')){
        var arrowShow = $homepageSlider.find('.gallery-cell').length === 1 ? false : true;
        $homepageSlider.flickity({
                    adaptiveHeight: settings.adaptiveHeight,
                    wrapAround: true,
                    cellAlign: 'left',
                    imagesLoaded: true,
                    prevNextButtons: arrowShow,
                    draggable: arrowShow,
                    pageDots: usePageDots,
                    autoPlay: settings.slideshowSpeed,
                    arrowShape: 'M41,50l35.8-35.8c1.6-1.6,2.4-3.8,2.4-5.9s-0.8-4.3-2.4-5.9c-3.3-3.3-8.5-3.3-11.8,0L23.3,44.1c-1.6,1.6-2.4,3.8-2.4,5.9 c0,2.1,0.8,4.3,2.4,5.9l41.7,41.7c1.6,1.6,3.8,2.4,5.9,2.4c2.1,0,4.3-0.8,5.9-2.4c3.3-3.3,3.3-8.5,0-11.8L41,50z',
                  });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $homepageSlider.data('flickity');
          setTimeout(function() {
            $homepageSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $homepageSlider.on( 'select.flickity', function() {
            if($homepageSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $homepageSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $homepageSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find('.gallery-cell').length > 1) {
        $homepageSlider.addClass('multi-image');
      } else {
        $homepageSlider.addClass('single-image');
      }

      $homepageSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },
  unload: function($target){

    var $slider = $target.find('.js-homepage-slideshow');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Testimonials
==============================================================================*/

var testimonial = {
  init: function(){

    $('.js-testimonial').each(function (index, value){
      var $testimonialSlider = $(this);
      var settings = {
        slideshowSpeed: $testimonialSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $testimonialSlider.data('slideshow-text-animation')
      }

      if( $('.testimonial-image').length > 0){
        $('.testimonial-block').each(function(){
          if( $(this).find('.testimonial-image').length == 0){
            var theBlock = $(this).closest('.testimonial-block');
            $(theBlock).addClass('set-testimonial-height');
          }
        })
      }

      //initiate the slideshow
      if (!$testimonialSlider.hasClass('flickity-enabled')){
        var arrowShow = $testimonialSlider.find('.gallery-cell').length === 1 ? false : true;
        $testimonialSlider.flickity({
                        wrapAround: true,
                        cellAlign: 'left',
                        imagesLoaded: true,
                        prevNextButtons: arrowShow,
                        draggable: arrowShow,
                        pageDots: usePageDots,
                        autoPlay: settings.slideshowSpeed,
                        arrowShape: arrowSize
                      });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $testimonialSlider.data('flickity');
          setTimeout(function() {
            $testimonialSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $testimonialSlider.on( 'select.flickity', function() {
            if($testimonialSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $testimonialSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $testimonialSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($testimonialSlider.find('.gallery-cell').length > 1) {
        $testimonialSlider.addClass('multi-image');
      } else {
        $testimonialSlider.addClass('single-image');
      }

      $testimonialSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width()+10;
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },

  unload: function($target){
    var $slider = $target.find('.js-testimonial');

    $slider.flickity('destroy');

  }
}

/*============================================================================
  Gallery
==============================================================================*/

var gallery = {
  init: function(){

    $('.gallery-horizontal').find('.gallery-image-wrapper').each(function(){
      var wrapper = $(this);
      var images = $(this).find("img");
      var imgWidth,
          imgHeight;

      $("<img />").attr("src", $(images).attr("src")).on('load', function() {
        imgWidth = this.width;
        imgHeight = this.height;

        $(wrapper).css("flex-basis", imgWidth * 200 / imgHeight);
        $(wrapper).css("flex-grow", imgWidth * 200 / imgHeight);
        $(wrapper).find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    });
  });

  $('[rel=gallery]').fancybox({
    baseClass: "gallery-section__lightbox",
    clickContent: "nextOrClose"
  })

  }
}

/*============================================================================
  Video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var videoSection = {
  init: function(){

    //Initialize lazy videos
    lazyframe('.lazyvideo--autoplay--true', {
      initinview: true,
    });

    lazyframe('.lazyvideo--autoplay--false', {
      initinview: false,
    });

    lazyframe('.lazyvideo--product-video');

    //Wrap product description iframes in responsive lazyframe div
    $('.product_section .description').find('iframe').wrap('<div class="lazyframe" data-ratio="16:9"></div>');



    function hideTextElements(parent) {
      parent.find('.caption').hide();
      parent.find('.action_button').hide();
    }

    var videoElement = $('.js-video.hide-text-on-video.video-autoplay--true').parents('.js-video-section');
    hideTextElements(videoElement);


    if($('.js-video').hasClass('hide-text-on-video') && $('.js-video').hasClass('video-autoplay--true')){
      var videoSection = $('.js-video').parents('.js-video-section');
      hideTextElements(videoSection);
    }

    $(".video-section .lazyvideo.hide-text-on-video").on('click', function(){
      var videoSection = $(this).parents('.js-video-section');
      hideTextElements(videoSection);
    })

    $('[data-play-video-button], video.hide-text-on-video, .lazyvideo--autoplay--false').on('click', function(){
      //Target parent lazyframe
      var videoSection = $(this).parents('.js-video-section');
      var lazyElement = videoSection.find('.lazyframe');
      var videoWrapper = videoSection.find('.js-video');
      if(videoWrapper.data('mp4') || videoWrapper.data('ogv')) {
        videoSection.find('video')[0].play();
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      } else{
        //create iframe and add settings
        var lazyIframe = document.createElement('iframe');
        iframeSrc = lazyElement.data('src');
        cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf('?')) + '?&autoplay=1';
        lazyIframe.src = cleanIframeSrc;
        lazyIframe.setAttribute('allowfullscreen', true);
        lazyIframe.setAttribute('frameborder', 0);
        //Append iframe to lazyframe
        lazyElement.append(lazyIframe);
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      }
    });
  },
  unload: function($target){
    $target.find('[data-play-video]').off('click');
    $target.find('video.hide-text-on-video').off('click');
  }
}

/*============================================================================
  Cart
==============================================================================*/
var cart = {
  init: function(){
    if ($('#cart_form .tos_agree').length) {
      //Terms of service on cart page
      $('body').on('click', "#cart_form input[type='submit']", function() {
        if ($(this).parents('form').find('.tos_agree').is(':checked')) {
          $(this).submit();
        } else {
          var warning = '<p class="warning animated bounceIn">' + "You must agree with the terms and conditions to checkout." + '</p>';
          if ($('p.warning').length == 0) {
            $(this).before(warning);
          }
          return false;
        }
      });
    }

    //Refresh page on add to cart if on cart page
    if($('body').hasClass('cart')) {
      $('.product_form form').on("submit", function(){
        setTimeout(function(){
          document.location.href = "/cart";
        }, 500);
      });
    }
  }
}

/*============================================================================
  Product
==============================================================================*/

selectCallback = function(variant, selector) {

  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form, .shopify-product-form', $product);
  var variantInventory = $productForm.data('variant-inventory');

  var $notifyFormInputs = $('.notify_form__inputs');

  var notifyEmail = "Enter your email address...";
  var notifyEmailValue = "";
  var notifySend = "Notify me";

  var notifyUrl = $notifyFormInputs.data('url');
  var notifyMessage = "Please notify me when "+" becomes available - "+notifyUrl;
if(variant != null){
	var notifyMessage = "Please notify me when "+variant.title+" becomes available - "+notifyUrl;
}
  if ($notifyFormInputs.hasClass('customer--true')) {
    var notifyCustomerEmail = "";
    var notifyEmailInput = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="'+ notifyCustomerEmail +'" />'
  } else {
    var notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="'+ notifyEmail +'" value="'+ notifyEmailValue +'" />';
  }
  var notifyFormHTML = notifyEmailInput+'<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="'+ notifyMessage +'" value="'+ notifyMessage +'" /><input class="action_button" type="submit" value="'+ notifySend + '" style="margin-bottom:0px" />';

  //Image Variant feature
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $('.js-product-gallery, .js-gallery-modal', $product);
    $sliders.each(function() {

      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($slider.is(":visible") && $sliderInstance != undefined ) {
        var index = $('[data-image-id="' + variant.featured_image.id + '"]').data('index');
        $sliderInstance.select( index, false, true );
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function(v){
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);

    
      for (var i=0,length=variant.options.length; i<length; i++) {
       var radioButton = $productForm.find('.swatch:not(.swatch-size)[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
      }
     }
    
  }

  if (variant && variant.available == true) {
    if(variant.price < variant.compare_at_price){
      var discount =parseInt(Math.ceil(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price));
      
      $('.price_discount', $product).html('-' + discount + '%').removeClass('is-hide');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was_price', $product).html('');
      $('.savings', $product).html('');
		$('.price_discount', $product).html('').addClass('is-hide');
		$('.current_price', $product).parent().removeClass('sale');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      
      
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    
    $('.add_to_cart', $product).removeClass('disabled out-of-stock').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).show();
    $notify_form.hide();
    $notifyFormInputs.empty();
  } else {
    var message = variant ? "Sold Out" : "Unavailable";
    $('.was_price', $product).text('');
    $('.savings', $product).text('');
    $('.current_price', $product).text('');
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
    $('.add_to_cart', $product).addClass('disabled out-of-stock').attr('disabled', 'disabled').find('span').text(message);
    $('.shopify-payment-button', $product).hide();

    $notify_form.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notify_form.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }

  
};

var productPage = {
  init: function(){
    var stickyForm = $('.js-product-sticky-form');
    var productForm = $('.product-info-wrap .product_form');
    var galleryNav = $('.regular-gallery .product_gallery_nav');
    var productGallery = $('.regular-gallery .js-product-gallery');
    var pageFooter = $('.footer-section');
    var productGalleryInitialized = false;

    var initProductGallerySlider = function() {
      productGalleryInitialized = true;

      productGallery.slick({
        lazyLoad: 'ondemand',
        arrows: false,
        dots: true,
      });
    };

    if (stickyForm.length) {

      $(window).scroll(function() {
        if ($(window).width() <= 798) {
          pageFooter.css({
            marginBottom: stickyForm.outerHeight(),
          });

          if ((productForm.offset().top + productForm.height()) - $(window).scrollTop() >= 0) {
            stickyForm.removeClass('is--active');
          } else {
            stickyForm.addClass('is--active');
          }
        }
      });
    }

    $(window).on('resize', function() {
      if ($(window).width() <= 798 && !productGalleryInitialized) {
        initProductGallerySlider();
      } else if ($(window).width() > 798 && productGalleryInitialized) {
        productGalleryInitialized = false;
        productGallery.slick('unslick');
      }
    })

    galleryNav.find('.gallery-cell').on('click', function(e) {
      e.preventDefault();
      var offset = productGallery.find('.gallery-cell').eq($(this).index()).offset().top;
      $('html, body').animate({
        scrollTop: offset,
      }, 300);
    });

    // ZALANDO LIKE GALLERY
    var zalandoLikeGalleryNav = $('.zalando-like-gallery .product_gallery_nav');
    var zalandoProductGallery = $('.zalando-like-gallery .js-product-gallery');
    zalandoLikeGalleryNav.find('.gallery-cell').on('mouseover', function(e) {
      zalandoProductGallery.find('.gallery-cell').hide();
      zalandoProductGallery.find('.gallery-cell').eq($(this).index()).show();
    });


    var initZalandoProductGallerySlider = function() {
      zalandoProductGalleryInitialized = true;
      $('.zalando-like-gallery .gallery-cell').show();
      zalandoProductGallery.slick({
        lazyLoad: 'ondemand',
        arrows: false,
        dots: true,
      });
    };

    if ($(window).width() <= 798) {
      initProductGallerySlider();
      initZalandoProductGallerySlider();
    }

    if($('.js-full-width-product-images').length){
      imageFunctions.fullWidth('.product-template .product .description img', '.js-full-width-product-images');
    }

    if(is_touch_device() && $('.js-product-gallery').hasClass('popup-enabled--false')) {
      imageFunctions.zoom('.js-product-gallery');
    } else if(is_touch_device() == 0) {
      imageFunctions.zoom('.js-product-gallery', false);
    }

    $(".js-product_section .product_form_options").each(function() {
      new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html("Thanks! We will notify you when this product becomes available!");
    }

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    
      $('body').on('change', '.swatch :radio', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        var parentForm = $(this).closest('.product_form form');


        if (parentForm.siblings('.notify_form').length){
          var notifyForm = parentForm.siblings('.notify_form');
        } else {
          var notifyForm = $('.js-notify-form');
        }

        var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

        if (option1 && option2 && option3){
          var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
        } else if (option1 && option2){
          var notifyMessage = option1 + ' / ' + option2;
        } else {
          var notifyMessage = option1;
        }

        notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage );

        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    

    $('.js-product-gallery a').fancybox({
      baseClass: "product-section__lightbox",
      clickContent: false,
      afterShow: function(instance, slide) {
        const zoom = instance.$trigger.first().parents('.js-product-gallery').data('zoom');
        if (zoom){
          $('.fancybox-image')
              .wrap('<span class="zoom-wrap" style="display:inline-block"></span>')
              .css('display', 'block')
              .parent()
              .zoom({
                touch: false,
                magnify: 1
          });
        }
      },
      afterClose: function(instance, slide) {
        const $instanceGallery = instance.$trigger.first().parents('.js-product-gallery');
        $instanceGallery.hide();
        setTimeout(function(){
          $instanceGallery.fadeIn(100);
        }, 1);
      }
    })

  },
  productSwatches: function(){
    //Swatches linked with selected options
    
      if ($('.js-product_section').length){
        var $productForms = $('.js-product_section').find('.product_form');
        $productForms.addClass('is-visible');

        //Loop through each product and set the initial option value state

        $productForms.each(function(){
          var JSONData = $(this).data('product');
          var productID = $(this).data('product-id');
          var productSection = '.product-' + productID + ' .js-product_section';
          var swatchOptions = $(this).find('.swatch_options .swatch');
          if (swatchOptions.length > 1){
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }

      //Add click event when there is more than one product on the page (eg. Collection in Detail)
      if ($('.js-product_section').length > 1){
        $('body').on('click', '.swatch-element', function(){
          var swatchValue = $(this).data('value').toString();

          $(this)
          .siblings('input[value="'+ swatchValue.replace(/\"/g,'\\"') +'"]')
          .prop("checked", true)
          .trigger("change");

          var JSONData = $(this).parents('.product_form').data('product');
          var productID = $(this).parents('.product_form').data('product-id');
          var productSection = '.product-' + productID + ' .js-product_section';
          var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

          if (swatchOptions.length > 1){
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        })
      }
    
  },
  relatedProducts: function(){

    $('.js-related-products-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide') || 3;
      var products_limit = $(this).data('products-limit') || 14;
      var products_available = $(this).data('products-available') || 14;
      var cellAlign = "left",
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      var defaultSliderResponsive = [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }
      ];

      if($(this).hasClass('js-related-product-popup')) {
        defaultSliderResponsive = [
          {
            breakpoint: 1680,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 1240,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          }
        ];
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

        $(this).slick({
            nextArrow: '<button type="button" class="slick-next">'+arrowIconSvg+'</button>',
            prevArrow: '<button type="button" class="slick-prev">'+arrowIconSvg+'</button>',
            dots: usePageDots,
            arrows: prevNext,
            infinite: wrapAround,
            slidesToShow: 4,
            slidesToScroll: 2,
            responsive: defaultSliderResponsive,
            lazyLoad: 'ondemand',
        });

        $(this).addClass('slider-initialized');
    });
  },
  initializeQuantityBox: function(){

    $('body').on('click', '.js-change-quantity', function() {
        var $this = $(this),
            $input = $(this).siblings('input'),
            val = parseInt($input.val()),
            valMax = 100000000000000000000000000000,
            valMin = $input.attr('min') || 0;

        if ($input.attr('max') != null){
          valMax = $input.attr('max');
        }

        if(isNaN(val) || val < valMin) {
            $input.val(valMin);
            return false;
        } else if (val > valMax) {
            $input.val(valMax);
            return false;
        }

        if($this.data('func') == 'plus') {
            if(val < valMax) $input.val(val + 1);
        } else {
            if(val > valMin) $input.val(val - 1);
            if($this.parents(".cart_item").length) {
              if (val - 1 == 0) {
                $this.closest('.cart_item').addClass('animated fadeOutUp')
              }
            }
        }
        $input.trigger('change');

    });
  },
  unload: function($target){

    var $slider = $target.find('.products-slider');
      if ($slider.hasClass('slider-initialized')){
          $slider.slick('unslick');
      }

  }
}

/*============================================================================
  Header
==============================================================================*/

var header = {
  init: function(){
    var $container = $('#shopify-section-header');
    var clicked;
    var toggleSearchForm = function(e) {
      if (e) {
        e.stopPropagation();
      }
      $(document).off('click', onClickSearchFormOutside);

      var forms = $('[data-search-form]', $container).toggleClass('is--active');

      if (forms.hasClass('is--active')) {
        $(document).on('click', onClickSearchFormOutside);
        forms.filter(':visible').find('input[name="q"]')[0].focus();
      }
    };

    var onClickSearchFormOutside = function(e) {
      var target = $(e.target);

      if (!target.closest('[data-search-form]').length) {
        $(document).off('click', onClickSearchFormOutside);
        toggleSearchForm();
      }
    };

    var initMobileMenu = function() {
      var menu = $('[data-mobile-menu]', $container);
      $('[data-dropdown-toggle]', menu).off('click').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var menu_item = $(this).closest('.sublink');
        var dropdown = menu_item.find('> .vertical-menu_submenu, > .vertical-menu_sub-submenu');

        dropdown.slideToggle(300, function() {
          menu_item.find('> .dropdown_link--vertical').toggleClass('active');
        });
      });
    };

    var closeDropdown = function() {
      $('body').removeClass('is-active');
      $('.dropdown_link').removeClass('active_link');
      $('.dropdown_container:not(.js-mobile_menu)').hide();
    };

    var closeMiniCart = function() {
        console.log(1);
    	$('html').removeClass('is--locked');
      $('body').removeClass('is-active').removeClass('blocked-scroll');
      $('.dropdown_link').toggleClass('active_link');
      var $cart_container = $('[data-mini-cart-container]');
      $cart_container.removeClass('active_link').removeClass('open_cart_mini');
      $('.related-product-modal--container.active').removeClass('active');

      var $recommended_products_container = $('.related-product-modal--container');
      var $mini_cart_recommended_products_container = $('.mini-cart-related-products--container');

      if ($recommended_products_container) {
        $recommended_products_container.removeClass('active');
      }

      if ($mini_cart_recommended_products_container) {
        $mini_cart_recommended_products_container.removeClass('active');
      }
    };

    var openMiniCart = function($cart_container) {
      $('html').addClass('is--locked');
      $('.dropdown_link').removeClass('active_link');
      $cart_container.addClass('active_link').addClass('open_cart_mini');

      var $recommended_products_container = $('.related-product-modal--container');
      var $mini_cart_recommended_products_container = $('.mini-cart-related-products--container');

      if ($recommended_products_container) {
        $recommended_products_container.addClass('active');
      }

      if ($mini_cart_recommended_products_container) {
        $mini_cart_recommended_products_container.addClass('active');
      }
    };

    $container.on('click', '[data-search-toggle]', toggleSearchForm);
    initMobileMenu();

    //Vertical menu enabled
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical, .vertical-menu_submenu').on('mouseover', function(e) {
        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        var clickCount = $(this).attr('data-click-count');

        $('.active_link').removeClass('active_link');
        if(!$(this).hasClass('active_link')) {
          $(this).children('a').addClass('active_link');
          // $('.is-absolute').parent().removeClass('feature_image');
        }
      });

      //Enable touch on parent link if on touch device and desktop menu is visible
      if(is_touch_device()){
        $('.vertical-menu .sublink a, .vertical-menu_submenu .sublink a').on('touchstart click', function(e) {
          e.stopPropagation();

          var verticalMenu = $(this);

          if(e.type == "touchstart") {
            clicked = true;
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu);
              e.preventDefault();
            }
          }
          else if(e.type == "click" && !clicked) {
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu);
              e.preventDefault();
            }
          }
          else {
            clicked = false;
          }


          if(!$('.currency-switcher').hasClass('open-menu') && $(window).width() < 800){
            $('.currency-switcher').addClass('open-menu')
          }

          function openDropdown(verticalMenu) {

            var $dropdownMegaMenu = $(verticalMenu).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
            var $dropdownVertical = $(verticalMenu).next('.vertical-menu_submenu');
            var clickCount = $(verticalMenu).attr('data-click-count');

            $('.dropdown_link--vertical').not(verticalMenu).attr('data-click-count', 0);
            $('.dropdown_link--vertical').attr('data-no-instant', true);
            $('.dropdown_container:not(.js-mobile_menu)').hide();

            $dropdownMegaMenu.show();
            $('.vertical-menu_submenu').removeClass('is-visible');
            $dropdownVertical.addClass('is-visible');

            //capture touch event
            if (e.type == 'touchstart'){
              clickCount++;
              $(verticalMenu).attr('data-click-count', clickCount);

              if (clickCount < 2){
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            }
          }
        });
      }
    }

    if ($('.promo_banner').length){
      var promo_banner = Cookies.get('promo_banner');

      if (promo_banner != 'dismiss') {
        $('body').addClass('promo_banner-show');
        $('.promo_banner').on('click', '.promo_banner-close', function(){
          $('body').removeClass('promo_banner-show');
          Cookies.set('promo_banner', 'dismiss', { expires: 30 });
        });
      }
    }
    //countdown

      var countdownEl=$('.js-countdown');
      var countdownDays=$('.js-countdown-days');
      var countdownHours=$('.js-countdown-hours');
      var countdownMinutes=$('.js-countdown-minutes');
      var countdownSeconds=$('.js-countdown-seconds');
      if (countdownEl.length>0) {
          // Set the date we're counting down to
          var monthNames = [
              "January", "February", "March",
              "April", "May", "June", "July",
              "August", "September", "October",
              "November", "December"
          ];
          var dateDefault=monthNames[(parseInt(countdownEl.attr("data-month"))-1)]+' '+countdownEl.attr("data-day")+', '+countdownEl.attr("data-year")+' '+countdownEl.attr("data-hours")+':'+countdownEl.attr("data-minute")+':00';
          var countDownDate = new Date(dateDefault).getTime();

          // Update the count down every 1 second
          var x = setInterval(function() {

              // Get today's date and time
              var now = new Date().getTime();

              // Find the distance between now and the count down date
              var distance = countDownDate - now;

              // Time calculations for days, hours, minutes and seconds
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              var seconds = Math.floor((distance % (1000 * 60)) / 1000);
              if(days<10){
                  days='0'+days;
              }
              if(hours<10){
                  hours='0'+hours;
              }
              if(minutes<10){
                  minutes='0'+minutes;
              }
              if(seconds<10){
                  seconds='0'+seconds;
              }
              countdownDays.text(days);
              countdownHours.text(hours);
              countdownMinutes.text(minutes);
              countdownSeconds.text(seconds);
              $('.promo_banner').addClass('is-show');
              // If the count down is finished
              if (distance < 0) {
                  clearInterval(x);
                  countdownDays.text('00');
                  countdownHours.text('00');
                  countdownMinutes.text('00');
                  countdownSeconds.text('00');
                  countdownEl.remove();
              }
          }, 1000);
      }


      //offscreen check for menu
    $('.vertical-menu_submenu, .vertical-menu_sub-submenu').each(function() {
      if($(this).is(':off-right')) {
        $(this).addClass('vertical-menu--align-right');
      }
    });

    //Click anywhere outside of dropdown to close
    $('html').on('click', function(event) {
     // if (!$(event.target).closest('.cart_container').length && $('.cart_content').is(':visible')) {

       // closeMiniCart();
      //}

      if (!$(event.target).closest('.dropdown_container').length && $('.dropdown').is(':visible')) {

        closeDropdown();
      }

    });


    //Only apply on larger screen sizes
    if ($(window).width() > 798) {
      if ($('.header').hasClass('header-fixed--true')){

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('.main_nav_wrapper.sticky_nav').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });

        // if (!$('.main_nav_wrapper').hasClass('sticky_nav')) {
        //   var sticky_nav = new Headhesive('.main_nav_wrapper', {
        //     offset: 700,
        //     throttle: 300,
        //     classes: {
        //       clone: 'sticky_nav',
        //       stick: 'sticky_nav--stick',
        //       unstick: 'sticky_nav--unstick'
        //     },
        //     onInit: function() {
        //       $(".sticky_nav .secondary_logo").css('display', 'none');
        //       $(".sticky_nav .primary_logo").css('display', 'block');
        //       $(".sticky_nav .icon-search").css('display', 'block');
        //       $(".sticky_nav .search_container").css('display', 'none');
        //       
        //         var sticky_nav_height = $(".sticky_nav .nav").height() + 5;
        //       
        //       $(".sticky_nav .mini_cart").css("height", $(".sticky_nav").height() + 5);

        //     },
        //     onUnstick: function() {
        //       $('.cart_container').removeClass('active_link');
        //     }
        //   });

        // }
      } else {
        $('.header-fixed--true').removeClass('header-fixed--true');
        if ($('.main_nav_wrapper').length > 1) {
          $('.main_nav_wrapper').first().remove();
        }
      }

      if ($('img.primary_logo:visible')){
        $('.logo img', $(".feature_image .header")).attr('src', $('.logo img').data('src-home'));
      } else {
        $('.logo img').attr('src', $('.logo img').data('src'));
      }
    //Mobile menu
    } else {
      if ($('#header').hasClass('mobile_nav-fixed--true')){
        $('body').addClass('mobile_nav-fixed--true');

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('#header').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });
      } else {
        $('body').addClass('mobile_nav-fixed--false');
      }

    }


    if ( is_touch_device() || $(window).width() <= 798 ) {

      $('.dropdown_link').attr('data-no-instant', true);

      $('body').on('click', '.dropdown_link', function(e) {
      	if($(this).hasClass('js-mobile_nav')){

        }else{
        $('.nav a').removeClass('active_link');

        if ($('#header').is(':visible')) {
          var $dropdown = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')

           // if(!$(this).hasClass('mini_cart')) {
             // $('.cart_container').removeClass('active_link');
            //}

        } else {

          if($(this).hasClass("icon-search")) {
            window.location = $(this).attr("href");
            return false;
          }

          var $dropdown = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
        }

        if ($dropdown.is(':visible') || $dropdown.attr('class') === undefined) {
          $dropdown.hide();
          $('body').removeClass('is-active');
        } else {
          $('.dropdown_container:not(.js-mobile_menu)').hide();
          $dropdown.show();
          $('body').addClass('is-active');
         // $('.mobile_nav').find('div').removeClass('open');
        }

        if ($dropdown.is(':visible')) {
          e.stopPropagation();
          return false;
        }
      	}
      });

      $('body').on("click", '.mobile_nav', function() {
		  //$('.js-mobile_menu').css('top', $('#header').height()).css('height','calc(100vh - '+$('#header').height()+'px)');
        $(this).find('div').toggleClass('open');
        $('.js-mobile_menu').toggleClass('dropdown_container--active');
        $('html').toggleClass('is--locked');
      });
		$('body').on("click", '.mobile_menu__close', function() {
      $('.mobile_nav').find('div').removeClass('open');
			$('.js-mobile_menu').removeClass('dropdown_container--active');
			$('html').removeClass('is--locked');
		});




      /*$('.cart_content__continue-shopping').on('click', function(e){
        closeMiniCart();
      })*/

    } else {

      $(".nav a, .logo a").not(".cart_content a").on("mouseenter", function() {
        if(!$(this).hasClass("active_link")) {
          $('.dropdown_container:not(.js-mobile_menu)').hide();
          $('.active_link').removeClass('active_link');
          // $('.is-absolute').parent().addClass('feature_image');
        }
      });

      $('.main_nav, .top_bar, .cart_container').on("mouseleave", function() {
        if ( $(window).width() > 798) {
          $('.dropdown_container:not(.js-mobile_menu)').hide();
        }
        $('.active_link').removeClass('active_link');
        // $('.is-absolute').parent().addClass('feature_image');
      });

      $('.dropdown_link, .dropdown_link--vertical').attr('data-click-count', 0);

      $('.dropdown_link').on('mouseover touchstart', function(e) {
        if ( $(window).width() > 798) {
          $('.dropdown_container:not(.js-mobile_menu)').hide();
        }

        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        var clickCount = $(this).attr('data-click-count');

        $('.active_link').removeClass('active_link');

        if(!$(this).hasClass('active_link')) {
          $dropdown.show();

          if($(this).hasClass('mini_cart')) {
            //$(this).parent('.cart_container').addClass('active_link');
          } else {
            if ( $(window).width() > 798) {
              $(this).addClass('active_link');
            }
            // $('.is-absolute').parent().removeClass('feature_image');
          }
        }

        //Enable touch on parent link if on touch device and desktop menu is visible
        if(is_touch_device()){
          $('.dropdown_link').not(this).attr('data-click-count', 0);
          $('.dropdown_link').attr('data-no-instant', true);


          //capture touch event
          if (e.type == 'touchstart'){
            clickCount++;
            $(this).attr('data-click-count', clickCount);

            if (clickCount < 2){
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        }

      });

    }
//Toggle mini-cart with menu icon
      /*$("body:not(.cart)  .mini_cart").on("click", function(e) {
          e.preventDefault();

          var $cart_container = $('[data-mini-cart-container]');
          if($cart_container.hasClass('open_cart_mini')) {
              closeMiniCart();
              //$('body').removeClass('blocked-scroll');
          } else {
              openMiniCart($cart_container);
              //$('body').addClass('blocked-scroll');
          }


      });*/
	  $(".cart_content-close").on("click", function(e) {
		  e.preventDefault();
		  closeMiniCart();
	  });
	  $(".cart-overlay").on("click", function(e) {
		  e.preventDefault();
		  closeMiniCart();
	  });


  },
  removeDataAttributes: function(target){
    if($(target).length){
      var i,
          $target = $(target),
          attrName,
          dataAttrsToDelete = [],
          dataAttrs = $target.get(0).attributes,
          dataAttrsLen = dataAttrs.length;

      for (i=0; i<dataAttrsLen; i++) {
        if ( 'data-' === dataAttrs[i].name.substring(0,5) ) {
          dataAttrsToDelete.push(dataAttrs[i].name);
        }
      }
      $.each( dataAttrsToDelete, function( index, attrName ) {
        $target.removeAttr( attrName );
      })
    }
  },
  loadMegaMenu: function(){

    //Remove old mega-menus so that theme-editor works properly
    $('.sticky_nav .mega-menu').remove();
    $('.header .mega-menu').remove();

    //Clone the mega menu from section into sticky_nav
    $('.mega-menu-container .mega-menu')
      .clone()
      .appendTo('.sticky_nav .main_nav');
    //Remove theme-editor data-attributes
    header.removeDataAttributes('.sticky_nav .mega-menu.dropdown_container .dropdown_column');

    //Loop through mega-menus to add arrow to parent
    $('.mega-menu-container .mega-menu').each(function(index){
      var megaMenuValue = $(this).data("dropdown");
      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .find('span')
        .remove();

      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .not('.icon-search')
        .append(' <span class="icon-down-arrow"></span>')
        .addClass('mega-menu-parent')
        .addClass('dropdown_link')
        .removeClass('top_link');

      $('[data-dropdown="' + megaMenuValue + '"]').each(function(index){
        if (!$(this).hasClass('mega-menu')) {
          $(this).remove();
        }
      });

      $(this).clone().appendTo('.header .main_nav');
    });

    //Remove default mega menus if vertical menus are selected
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu').remove();
      $('.dropdown_link--vertical:not(.mega-menu-parent)').each(function(index){
        var megaMenuValue = $(this).data('dropdown-rel');
        $('[data-dropdown="' + megaMenuValue + '"]').remove();
      })
    }

    $('.mega-menu-parent').on('mouseenter', function() {

      if(!$(this).hasClass('active_link')) {
        $('.dropdown_container:not(.js-mobile_menu)').hide();
        $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').toggle();

        $(this).addClass('active_link');
        // $('.is-absolute').parent().removeClass('feature_image');

      }
    });

    //Remove theme-editor data-attributes
    header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');

    if (is_touch_device() || $(window).width() <= 798) {
      $('.dropdown_link').attr('data-no-instant', true);
    }

    header.loadMobileMegaMenu();
  },
  loadMobileMegaMenu: function() {

    //Loop through mega menus and add to mobile menu
    $('.mega-menu-container .mobile-mega-menu').each(function(index){
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
        if (!$(this).hasClass('mobile-mega-menu')) {
          $(this).remove();
        }
      });
    });
  },
  unloadMegaMenu: function(){
    $('.header .mega-menu').remove();
    $('.mega-menu-container .mega-menu').each(function(index){
      var menuParent = $(this).data('dropdown');
      $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('.icon-down-arrow').remove();
    });
  },
  unload: function() {
    $('body').off('click', '.mobile_nav');
    $('body').off('click', '.dropdown_link');
    $('html').off('click');
    $('.mini_cart').off('click');
   // $('.cart_content__continue-shopping').off('click');
    $('body').off('click', '.banner a[href^="#"]');
  }
}

/*============================================================================
  Social media
==============================================================================*/

  var social = {
    twitter: function(){
      if (!window.twttr){
        //Initialize twitter feed
        window.twttr = (function (d,s,id) {
        var t, js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return; js=d.createElement(s); js.id=id;
        js.src="https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return window.twttr || (t = { _e: [], ready: function(f){ t._e.push(f) } });
        }(document, "script", "twitter-wjs"));
      }

      if (window.twttr) {
        window.twttr.ready(function (twttr) {
          twttr.widgets.load(
            document.getElementById("twitter-timeline")
          );
        });
      }
    },
    unload: function(){

    }
  }

  var instagram = {
    loadContent: function(s){
      if(s.clientID) {
        var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID;

        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'jsonp',
          success: function(data) {

            if(data.meta.code === 200 && data.data.length) {
              var data = data.data;
              var count = 0;
              s.el.empty();

              for(var i = 0; i < data.length; i++) {
                var thisMedia = data[i], item;

                var url = thisMedia.images.low_resolution.url;

                if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                  item = '<div class="il-photo__img instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link">'+item+'</a>';
                }

                if(thisMedia.videos) {
                  item = '<div class="instagram__video instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link instagram__video-link">'+item+'</a>';
                }

                if(item) {
                  item = '<div class="'+s.column+ ' columns instagram__item small-down--one-whole">'+item+'</div>';
                }
                if(item !== '') {
                  s.el.append(item);
                  count++;
                }
                if(count == s.limit) {
                  break;
                }
              }
            }
          },
          error: function() {
          }
        });
      }
    }
  }

  $('.social-feeds-wrap').each(function (index, value) {

    social.twitter();

    var $target = $(this).find(".js-instafeed");
    instagram.loadContent({
      el: $target,
      clientID: $target.data('client-id'),
      limit: $target.data('count'),
      column: $target.data('column')
    });
  });

/*============================================================================
  Show filters
==============================================================================*/

$(document).ready(function() {

  var wrapper = $('.fiter-warpper');
  var wrapperPosition = 0;
  var stickyFilterInitialized = false;
  var stickyFilterActive = true;
  var stickyFilterOpened = false;

  $('#open-filter').on('click', function(e){
    e.preventDefault();
    if($(this).hasClass('open-filter')) {
      stickyFilterOpened = false;
      $(this).removeClass('open-filter');
      wrapper.slideUp(500);
      $('html').removeClass('openfilters');
    } else {
      stickyFilterOpened = true;
      wrapper.slideDown(500);
      $(this).addClass('open-filter');
      $('html').addClass('openfilters');
      wrapper.scrollTop(0);
      wrapperPosition = wrapper.offset().top;
    }
  });

  $('#mobile-close, #mobile-bottom-close, .js-filter-apply').on('click', function(e){
    e.preventDefault();
    wrapper.slideUp(500);
    $('#open-filter').removeClass('open-filter');
    $('html').removeClass('openfilters');
    stickyFilterOpened = false;
  });

  function stickyFilterInit() {
    stickyFilterInitialized = true;

    $(document).scroll(function() {
      if (!stickyFilterActive || !stickyFilterOpened) {
        $('.fiter-content-wrap', wrapper).css({
          width: '',
          left: ''
        });

        return;
      }

      var docScroll = $(document).scrollTop() + 10;

        if(docScroll >= wrapperPosition && !wrapper.hasClass('is--fixed')) {
          var wrapperWidth = wrapper.outerWidth();
          var wrapperOffset = wrapper.offset().left;
          var wrapperHeight = wrapper.height();
          wrapper.addClass('is--fixed').css({
            height: wrapperHeight + 'px',
          });
          $('.fiter-content-wrap', wrapper).css({
            width: wrapperWidth,
            left: wrapperOffset
          });
        } else if (wrapper.hasClass('is--fixed') && docScroll < wrapperPosition) {
          wrapper.removeClass('is--fixed').css({
            height: '',
          });
          $('.fiter-content-wrap', wrapper).css({
            width: '',
            left: ''
          });
        }
    });

    $(window).on('resize', function() {
      if($(window).width() > 799) {
        stickyFilterActive = true;
      } else {
        stickyFilterActive = false;
      }
    });
  }

  var stickyInitWatcher = function() {
    if($(window).width() > 799 && !stickyFilterInitialized) {
      stickyFilterInit();
      $(window).off('resize', stickyInitWatcher);
    }
  };

  if($(window).width() > 799 && !stickyFilterInitialized) {
    stickyFilterInit();
  } else {
    $(window).on('resize', stickyInitWatcher);
  }
});

/*============================================================================
  Currency switcher
==============================================================================*/
$(document).ready(function() {
  let data = {"BD": "BDT", "BE": "EUR", "BF": "XOF", "BG": "BGN", "BA": "BAM", "BB": "BBD", "WF": "XPF", "BL": "EUR", "BM": "BMD", "BN": "BND", "BO": "BOB", "BH": "BHD", "BI": "BIF", "BJ": "XOF", "BT": "BTN", "JM": "JMD", "BV": "NOK", "BW": "BWP", "WS": "WST", "BQ": "USD", "BR": "BRL", "BS": "BSD", "JE": "GBP", "BY": "BYR", "BZ": "BZD", "RU": "RUB", "RW": "RWF", "RS": "RSD", "TL": "USD", "RE": "EUR", "TM": "TMT", "TJ": "TJS", "RO": "RON", "TK": "NZD", "GW": "XOF", "GU": "USD", "GT": "GTQ", "GS": "GBP", "GR": "EUR", "GQ": "XAF", "GP": "EUR", "JP": "JPY", "GY": "GYD", "GG": "GBP", "GF": "EUR", "GE": "GEL", "GD": "XCD", "GB": "GBP", "GA": "XAF", "SV": "USD", "GN": "GNF", "GM": "GMD", "GL": "DKK", "GI": "GIP", "GH": "GHS", "OM": "OMR", "TN": "TND", "JO": "JOD", "HR": "HRK", "HT": "HTG", "HU": "HUF", "HK": "HKD", "HN": "HNL", "HM": "AUD", "VE": "VEF", "PR": "USD", "PS": "ILS", "PW": "USD", "PT": "EUR", "SJ": "NOK", "PY": "PYG", "IQ": "IQD", "PA": "PAB", "PF": "XPF", "PG": "PGK", "PE": "PEN", "PK": "PKR", "PH": "PHP", "PN": "NZD", "PL": "PLN", "PM": "EUR", "ZM": "ZMK", "EH": "MAD", "EE": "EUR", "EG": "EGP", "ZA": "ZAR", "EC": "USD", "IT": "EUR", "VN": "VND", "SB": "SBD", "ET": "ETB", "SO": "SOS", "ZW": "ZWL", "SA": "SAR", "ES": "EUR", "ER": "ERN", "ME": "EUR", "MD": "MDL", "MG": "MGA", "MF": "EUR", "MA": "MAD", "MC": "EUR", "UZ": "UZS", "MM": "MMK", "ML": "XOF", "MO": "MOP", "MN": "MNT", "MH": "USD", "MK": "MKD", "MU": "MUR", "MT": "EUR", "MW": "MWK", "MV": "MVR", "MQ": "EUR", "MP": "USD", "MS": "XCD", "MR": "MRO", "IM": "GBP", "UG": "UGX", "TZ": "TZS", "MY": "MYR", "MX": "MXN", "IL": "ILS", "FR": "EUR", "IO": "USD", "SH": "SHP", "FI": "EUR", "FJ": "FJD", "FK": "FKP", "FM": "USD", "FO": "DKK", "NI": "NIO", "NL": "EUR", "NO": "NOK", "NA": "NAD", "VU": "VUV", "NC": "XPF", "NE": "XOF", "NF": "AUD", "NG": "NGN", "NZ": "NZD", "NP": "NPR", "NR": "AUD", "NU": "NZD", "CK": "NZD", "XK": "EUR", "CI": "XOF", "CH": "CHF", "CO": "COP", "CN": "CNY", "CM": "XAF", "CL": "CLP", "CC": "AUD", "CA": "CAD", "CG": "XAF", "CF": "XAF", "CD": "CDF", "CZ": "CZK", "CY": "EUR", "CX": "AUD", "CR": "CRC", "CW": "ANG", "CV": "CVE", "CU": "CUP", "SZ": "SZL", "SY": "SYP", "SX": "ANG", "KG": "KGS", "KE": "KES", "SS": "SSP", "SR": "SRD", "KI": "AUD", "KH": "KHR", "KN": "XCD", "KM": "KMF", "ST": "STD", "SK": "EUR", "KR": "KRW", "SI": "EUR", "KP": "KPW", "KW": "KWD", "SN": "XOF", "SM": "EUR", "SL": "SLL", "SC": "SCR", "KZ": "KZT", "KY": "KYD", "SG": "SGD", "SE": "SEK", "SD": "SDG", "DO": "DOP", "DM": "XCD", "DJ": "DJF", "DK": "DKK", "VG": "USD", "DE": "EUR", "YE": "YER", "DZ": "DZD", "US": "USD", "UY": "UYU", "YT": "EUR", "UM": "USD", "LB": "LBP", "LC": "XCD", "LA": "LAK", "TV": "AUD", "TW": "TWD", "TT": "TTD", "TR": "TRY", "LK": "LKR", "LI": "CHF", "LV": "EUR", "TO": "TOP", "LT": "LTL", "LU": "EUR", "LR": "LRD", "LS": "LSL", "TH": "THB", "TF": "EUR", "TG": "XOF", "TD": "XAF", "TC": "USD", "LY": "LYD", "VA": "EUR", "VC": "XCD", "AE": "AED", "AD": "EUR", "AG": "XCD", "AF": "AFN", "AI": "XCD", "VI": "USD", "IS": "ISK", "IR": "IRR", "AM": "AMD", "AL": "ALL", "AO": "AOA", "AQ": "", "AS": "USD", "AR": "ARS", "AU": "AUD", "AT": "EUR", "AW": "AWG", "IN": "INR", "AX": "EUR", "AZ": "AZN", "IE": "EUR", "ID": "IDR", "UA": "UAH", "QA": "QAR", "MZ": "MZN"};
  let currencyForm = $('#currency_form');
  let geoIpData = $('[data-location-checker]').data('geoip-url');
  let requestCurrency = undefined;
  let coockieCurrecy = bravaCookie.getCookie('user_currency');
  let {href} = window.location;
  let index = href.indexOf('?currency=');

  $('.currency-switcher .vertical-menu_submenu a').on('click touchend', function (e) {
      e.preventDefault();
      let value = $(this).text();
      $('.currency-switcher').addClass('hide-switcher');
      setTimeout(function(){
        if($(window).width() > 798) {
          $('.currency-switcher').removeClass('hide-switcher');
        }
        setCurrency(value);
        currencyForm.submit();
      }, 100);
  });
  if (index !== -1) {
      requestCurrency = href.slice((index + ('?currency=').length), ((index + ('?currency=').length) + 3));
      setCurrency(requestCurrency);
  } else {
    if(coockieCurrecy) {
      setCurrency(coockieCurrecy);
    } else {
      $.getJSON(geoIpData, function (response) {
        requestCurrency = data[response.result.code];
        setCurrency(requestCurrency);
      });
    }
  }

  function setCurrency(newCurrency) {
      let available = false;
      $('.currency-switcher .vertical-menu_submenu a').each(function () {
          if ($(this).text() === newCurrency) {
              available = true;
          }
      });
      if (available) {
          $('.curency-title').text(newCurrency);
          $('select[name="currency"]').val(newCurrency);

          if(coockieCurrecy !== newCurrency) {
              bravaCookie.setCookie('user_currency', newCurrency,{ path: '/', domain: 'bravafabrics.com' });
          }
      } else {
          return false;
      }
  }

  const symbols = {
    AUD: '$',
    CAD: '$',
    DKK: 'kr.',
    EUR: '€',
    GBP: '£',
    HKD: '$',
    JPY: '¥',
    NZD: '$',
    SGD: '$',
    USD: '$'
  };

  const currency = $('#currency_form').find('select').val();
  let topBarPrice = bravaCookie.getCookie('topbar');

  if(topBarPrice) {
    topBarPrice = JSON.parse(topBarPrice);
  }

  $('.promo_banner p').each(function(){
    parsePrice($(this));
  });
  function parsePrice (item) {
    if(item.text().length && item.text().indexOf('[[price ') !== -1) {
      let priceText = item.text();
      let startindex = priceText.indexOf('[[price ');
      let endIndex = priceText.indexOf(']]');
      let price = priceText.slice(startindex + 8, endIndex);
      let newText;
      let convertedPrice=-1;
		if(topBarPrice) {
        if(!(currency in topBarPrice)) {
           convertedPrice = Math.round(getEuros(currency, price)) + symbols[currency];
          topBarPrice[currency] = convertedPrice;
          bravaCookie.setCookie('topbar', JSON.stringify(topBarPrice));
          newText = priceText.replace('[[price ' + price + ']]', ' ' + convertedPrice);
        } else {
			convertedPrice=topBarPrice[currency];
          newText = priceText.replace('[[price ' + price + ']]', ' ' + topBarPrice[currency]);
        }
      } else {
         convertedPrice = Math.round(getEuros(currency, price)) + symbols[currency];
        let newCoockie = {};
        newCoockie[currency] = convertedPrice;
        bravaCookie.setCookie('topbar', JSON.stringify(newCoockie));
        newText = priceText.replace('[[price ' + price + ']]', ' ' + convertedPrice);
      }
      item.text(newText);
		var cartTotalFree=-1;
		for(var symbol in symbols){
			cartTotalFree=parseFloat(convertedPrice.replace(symbol,''))*100;
		}
		if(cartTotalFree<=parseInt($('.js-cart-form-free').attr('data-cart-total'),10)){
			$('.free-shiping').removeClass('hidden');
        }else{
			$('.free-shiping').addClass('hidden');
        }
		$('body').attr('data-free',cartTotalFree);
    }
  }

  function getEuros(currencyTo, convertoPrice) {
    return (Currency.convert(convertoPrice, 'EUR', currencyTo).toFixed(20));
  }

});

$(document).on('click', function(e){
    if(!$(e.target).closest('.vertical-menu_submenu.is-visible').length && $(window).width() < 800) {
      $('.vertical-menu_submenu').removeClass('is-visible');
      $('.currency-switcher .dropdown_link--vertical ').attr('data-click-count', 0);
      $('.currency-switcher .dropdown_link--vertical ').attr('data-no-instant', false);
      $('.open-menu').removeClass('open-menu');
    }
});


/*============================================================================
  Map
==============================================================================*/
var mapFunction = {
  init: function() {

    if($('.lazymap').length > 0){
      lazyframe('.lazymap');
    }

    if ($('.maps').hasClass('js-api-map')) {
      var mapsToLoad = [];
      //Create map settings array
      $('.map').each(function(i, obj) {
        mapsToLoad.push(this);
        mapsToLoad[i].sectionid = $(this).data('id');
        mapsToLoad[i].address = $(this).data('address');
        mapsToLoad[i].directions = $(this).data('directions-address');
        mapsToLoad[i].zoom = $(this).data('zoom');
        mapsToLoad[i].mapstyle = $(this).data('style');
        mapsToLoad[i].showpin = $(this).data('pin');
        mapsToLoad[i].apikey = $(this).data('api-key');
      });
      $.each(mapsToLoad, function(i, instance) {
        //Enable caching to avoid duplicate google maps files
        $.ajaxSetup({ cache: true });
        //Load maps script and find location coordinates
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey
        ).then(function() {
          mapFunction.findLocation(mapsToLoad[i]);
          $.ajaxSetup({ cache: false });
        });
      });
    }
  },
  findLocation: function(mapArray) {
    var geoLat;
    var geoLng;
    var geocoder = new google.maps.Geocoder();
    //Find and set coordinates
    geocoder.geocode({ address: mapArray.address }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng();
        //Create map
        mapFunction.initMap(geoLat, geoLng, mapArray);
      } else {
        console.log('Error:' + status);
      }
    });
  },
  initMap: function(lat, lng, mapArray) {
    var location = { lat: lat, lng: lng };
    var styleJson = [];
    //Set style JSON
    if(mapArray.mapstyle=='aubergine'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#1d2c4d'}]},{elementType:'labels.text.fill',stylers:[{color:'#8ec3b9'}]},{elementType:'labels.text.stroke',stylers:[{color:'#1a3646'}]},{featureType:'administrative.country',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#64779e'}]},{featureType:'administrative.province',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'landscape.man_made',elementType:'geometry.stroke',stylers:[{color:'#334e87'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#023e58'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#283d6a'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#6f9ba5'}]},{featureType:'poi',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#023e58'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#3C7680'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#304a7d'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'road',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#2c6675'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#255763'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#b0d5ce'}]},{featureType:'road.highway',elementType:'labels.text.stroke',stylers:[{color:'#023e58'}]},{featureType:'transit',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'transit',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'transit.line',elementType:'geometry.fill',stylers:[{color:'#283d6a'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#3a4762'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#0e1626'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#4e6d70'}]}]
    }else if(mapArray.mapstyle=='retro'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#ebe3cd'}]},{elementType:'labels.text.fill',stylers:[{color:'#523735'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f1e6'}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#c9b2a6'}]},{featureType:'administrative.land_parcel',elementType:'geometry.stroke',stylers:[{color:'#dcd2be'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#ae9e90'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#93817c'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#a5b076'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#447530'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#f5f1e6'}]},{featureType:'road.arterial',elementType:'geometry',stylers:[{color:'#fdfcf8'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#f8c967'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#e9bc62'}]},{featureType:'road.highway.controlled_access',elementType:'geometry',stylers:[{color:'#e98d58'}]},{featureType:'road.highway.controlled_access',elementType:'geometry.stroke',stylers:[{color:'#db8555'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#806b63'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'transit.line',elementType:'labels.text.fill',stylers:[{color:'#8f7d77'}]},{featureType:'transit.line',elementType:'labels.text.stroke',stylers:[{color:'#ebe3cd'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'water',elementType:'geometry.fill',stylers:[{color:'#b9d3c2'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#92998d'}]}]
    }else if(mapArray.mapstyle=='silver'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#f5f5f5'}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f5f5'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#bdbdbd'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},{featureType:'road.arterial',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#dadada'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#c9c9c9'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]}]
    }else if(mapArray.mapstyle=='night'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#242f3e'}]},{elementType:'labels.text.fill',stylers:[{color:'#746855'}]},{elementType:'labels.text.stroke',stylers:[{color:'#242f3e'}]},{featureType:'administrative.locality',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#263c3f'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#6b9a76'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#38414e'}]},{featureType:'road',elementType:'geometry.stroke',stylers:[{color:'#212a37'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#9ca5b3'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#746855'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#1f2835'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#f3d19c'}]},{featureType:'transit',elementType:'geometry',stylers:[{color:'#2f3948'}]},{featureType:'transit.station',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#17263c'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#515c6d'}]},{featureType:'water',elementType:'labels.text.stroke',stylers:[{color:'#17263c'}]}]}else{styleJson=[]}
    //Create google maps link
    $('.js-map-link').attr(
      'href',
      'https://www.google.com/maps/place/' +
        mapArray.directions +
        '/@' +
        lat +
        ',' +
        lng
    );
    //Set map options
    var mapOptions = {
      zoom: mapArray.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: false
    };
    //Create map
    var map = new google.maps.Map(
      document.getElementById(mapArray.sectionid),
      mapOptions
    );
    //Show pin
    if (mapArray.showpin == true) {
      var marker = new google.maps.Marker({
        position: location,
        map: map
      });
    }
  }
};

/*============================================================================
  FAQ
==============================================================================*/
var faqAccordion = {
  init: function(){
    var flg = 0;
    var $faqHeading = $('.faqAccordion > dt > button');
    $('.faqAccordion > dd').attr('aria-hidden',true);
    $faqHeading.attr('aria-expanded',false);
    $faqHeading.on('click activate',function(){
      if( flg ) return false;
      flg = 1;
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded',state);
      $(this).parent().next().slideToggle(function(){
        flg = 0;
      });
        $(this).parent().next().attr('aria-hidden',!state);
      return false;
    });
    $faqHeading.on('keydown',function(event){
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });
  }
}



/*============================================================================
  Accordion
==============================================================================*/

function initAccordion(accordionElem) {

  function handlePanelClick(event) {
    showPanel(event.currentTarget);
  }

  function showPanel(panelHeader) {

    let isActive,
        panel = panelHeader.parentNode,
        panelBody = panelHeader.nextElementSibling,
        expandedPanel = document.querySelector('.panel.active');

    if(panel) {
      isActive = (expandedPanel && panel.classList.contains('active')) ? true : false;

      if(expandedPanel) {
        expandedPanel.querySelector('.panel__inner').style.height = null;
        expandedPanel.classList.remove('active');
      }

      if(panel && !isActive) {
        panelBody.style.height = panelBody.scrollHeight + 'px';
        panel.classList.add('active');
      }
    }

  }

  let allPanelElements = document.querySelectorAll('.panel');

  for(let i = 0; i < allPanelElements.length; i++) {
    allPanelElements[i].querySelector('.panel__button').addEventListener('click', handlePanelClick);
  }

  showPanel(allPanelElements);
}

initAccordion(document.getElementsByClassName('accordion'));